import React, {Component} from 'react';
import './Account.css';
import FormCommunicate from "../common/FormCommunicate";
import {GET_PARAMETERS, post} from "../common/Http";

class AccountNotifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            communicate: '',
            marketing: undefined,
            portal: undefined,
            courses: undefined,
            progress: undefined
        };
    }

    componentDidMount() {
        fetch(`${process.env.REACT_APP_API_URL}/account/notifications`, GET_PARAMETERS)
            .then(response => response.json())
            .then(data => this.setState({
                marketing: data.notifications_marketing,
                portal: data.notifications_portal,
                courses: data.notifications_courses,
                progress: data.notifications_progress,
                loading: false
            }));
    }

    setNotifications(e) {
        e.preventDefault();
        this.setState({
            loading: true
        }, () => {
            fetch(`${process.env.REACT_APP_API_URL}/account/notifications`, post({
                notifications_marketing: this.state.marketing,
                notifications_portal: this.state.portal,
                notifications_courses: this.state.courses,
                notifications_progress: this.state.progress
            })).then(response => {
                this.setState({
                    loading: false,
                });
                if (response.ok) {
                    this.setState({
                        communicate: 'Zmiany zostały zapisane',
                        error: false
                    });
                } else {
                    throw Error
                }
            }).catch(error => {
                this.setState({
                    loading: false,
                    error: true,
                    communicate: 'Wystąpił błąd, zmiany nie zostały zapisane'
                });
            });
        });
    }

    render() {
        return (<div className="content account-content col-sm-12 col-md-9 col-lg-10">
            <h2>Zmiana ustawień powiadomień / wiadomości e-mail</h2>
            <div className="row">
                <form className="content-form">
                    <FormCommunicate communicate={this.state.communicate}
                                     error={this.state.error}/>
                    <div className="form-row">
                        <label htmlFor="marketing" className="w250">Zgoda na materiały marketingowe</label>
                        <select id="marketing"
                                disabled={this.state.loading}
                                value={this.state.marketing}
                                onChange={event => this.setState({marketing: event.target.value})}>
                            <option value={1}>Tak</option>
                            <option value={0}>Nie</option>
                        </select>
                    </div>
                    <div className="form-row">
                        <label htmlFor="portal" className="w250">Zgoda na powiadomienia o portalu</label>
                        <select id="portal"
                                disabled={this.state.loading}
                                value={this.state.portal}
                                onChange={event => this.setState({portal: event.target.value})}>
                            <option value={1}>Tak</option>
                            <option value={0}>Nie</option>
                        </select>
                    </div>
                    <div className="form-row">
                        <label htmlFor="courses" className="w250">Zgoda na powiadomienia o kursach</label>
                        <select id="courses"
                                disabled={this.state.loading}
                                value={this.state.courses}
                                onChange={event => this.setState({courses: event.target.value})}>
                            <option value={1}>Tak</option>
                            <option value={0}>Nie</option>
                        </select>
                    </div>
                    <div className="form-row">
                        <label htmlFor="progress" className="w250">Zgoda na powiadomienia o postępach</label>
                        <select id="progress"
                                disabled={this.state.loading}
                                value={this.state.progress}
                                onChange={event => this.setState({progress: event.target.value})}>
                            <option value={1}>Tak</option>
                            <option value={0}>Nie</option>
                        </select>
                    </div>
                    <div className="form-row">
                        <label className="w250"/>
                        {this.state.loading ?
                            <div className="spinner"/> :
                            <button className="small primary"
                                    onClick={event => this.setNotifications(event)}>
                                Zapisz zmiany
                            </button>}
                    </div>
                </form>
            </div>
        </div>);
    }
}

export default AccountNotifications;
